<template>
    <b-form-group :label="variable.description">
        <b-form-input v-model="variable.value" :name="variable.name" :type="type" :placeholder="variable.description"></b-form-input>
    </b-form-group>
</template>

<script>
export default {
    name: "Input.vue",
    props: {
        variable: {
            type: Object,
            required: true
        }
    },
    computed: {
        type() {
            switch (this.variable.type) {
                case 'email':
                    return 'email';
                case 'numeric':
                    return 'number';
                default:
                    return 'text';
            }
        }
    }
}
</script>
